<!-- Start footer -->
<footer class="custom-footer bg-dark py-5 position-relative">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 mt-4">
                <div>
                    <div>
                        <img src="assets/images/logo-light.png" alt="logo light" height="150">
                    </div>
                    <div class= "mt-4 fs-13">
                        <p>Fourmi Solutions</p>
                        <p class="ff-secondary">Customized Software Development Company</p>
                    </div>
                </div>
            </div>

        </div>

        <div class="row text-center text-sm-start align-items-center mt-5">
            <div class="col-sm-6">

                <div>
                    <p class="copy-rights mb-0">
                        {{year}} © Fourmi Solutions
                    </p>
                </div>
            </div>
        </div>
    </div>
</footer>
<!-- end footer -->
